import { useRef, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { uploadImage } from "../../lib/api";

export const ImageUploadField = ({ label, value, onChange, testid }) => {
  const input = useRef(null);
  const [busy, setBusy] = useState(false);
  const [broken, setBroken] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      onChange(await uploadImage(file));
      setBroken(false);
      toast.success("Image téléversée");
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Échec du téléversement");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div>
      <label className="text-xs font-body text-[#4A4A4A] mb-1 block">{label}</label>
      <div className="flex gap-2 items-center">
        {value && !broken && <img src={value} alt="" onError={() => setBroken(true)} className="h-9 w-12 object-contain bg-white border border-[#D1CFC7]" data-testid={`${testid}-preview`} />}
        <input value={value || ""} onChange={(e) => { setBroken(false); onChange(e.target.value); }} placeholder="URL ou téléversez un fichier" data-testid={testid} className="flex-1 min-w-0 bg-[#FAF9F6] border border-[#D1CFC7] focus:border-[#2C402E] px-3 py-2 outline-none font-body text-sm" />
        <button type="button" onClick={() => input.current?.click()} disabled={busy} data-testid={`${testid}-upload-button`} className="flex items-center gap-1 border border-[#2C402E] text-[#2C402E] hover:bg-[#2C402E] hover:text-[#FAF9F6] px-3 py-2 text-xs font-body whitespace-nowrap transition-colors disabled:opacity-50">
          {busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />} Téléverser
        </button>
        <input ref={input} type="file" accept="image/png,image/jpeg,image/webp,image/gif" onChange={onFile} className="hidden" data-testid={`${testid}-file`} />
      </div>
      {value && broken && <p className="text-[11px] font-body text-[#9E4735] mt-1" data-testid={`${testid}-broken`}>Ce lien n'est pas une image affichable. Téléversez plutôt le fichier.</p>}
    </div>
  );
};
